import { Button as Mui4Button, ButtonProps as Mui4ButtonPropsType, makeStyles } from '@material-ui/core'
import { ButtonProps as Mui5ButtonPropsType, default as Mui5Button } from '@mui/material/Button'
import React, { forwardRef } from 'react'
import { useComponentVersion } from '../hooks/useComponentVersion'

export enum OsButtonVersion {
  V1 = 1, // Base MUI
  V2 = 2, // Basic style fixes
  V3 = 3, // MUI5 + Stratis
}

const V3_BUTTON_COLORS = ['info', 'error', 'warning', 'success']
export type ButtonProps = Omit<Mui4ButtonPropsType, 'color' | 'size'> & {
  color?: Mui5ButtonPropsType['color'] | Mui4ButtonPropsType['color']
  size?: Mui5ButtonPropsType['size'] | Mui4ButtonPropsType['size']
  sx?: Mui5ButtonPropsType['sx']
  testId?: string
}

// TODO: get rid of this
export type OsButtonProps = ButtonProps & {
  testId?: string
}

const useStyles = makeStyles(
  {
    v2: {
      height: 'unset',
      padding: '8.5px 15px',

      '&.Mui4Button-sizeSmall': {
        height: 'unset',
        padding: '7px 12px',
      },

      '& .Mui4Button-label': {
        textTransform: 'none',
      },
    },
  },
  { name: 'OsButton' }
)

export const Button = forwardRef<HTMLButtonElement, OsButtonProps>((props, ref) => {
  const classes = useStyles()

  let version = useComponentVersion('button')
  let { color, testId, ...rest } = props
  switch (version) {
    case OsButtonVersion.V3:
      let color5: Mui5ButtonPropsType['color'] = color === 'default' || !color ? 'info' : color
      return (
        <Mui5Button
          disableRipple
          ref={ref}
          color={color5}
          {...(testId !== undefined ? { 'data-testid': testId } : {})}
          {...rest}
        />
      )

    default:
      const mui4Props: Mui4ButtonPropsType = {
        ...rest,
        className: `${version === OsButtonVersion.V2 ? classes.v2 : ''} ${props.className ? props.className : ''}`,
        color: color && V3_BUTTON_COLORS.includes(color) ? 'default' : (color as Mui4ButtonPropsType['color']),
        size: props.size === 'xXSmall' || props.size === 'xSmall' ? 'small' : props.size, // MUI4 does not support xXSmall
        ...(testId !== undefined ? { 'data-testid': testId } : {}),
      }
      return <Mui4Button ref={ref} {...mui4Props}></Mui4Button>
  }
})

declare module '@mui/material/Button' {
  interface ButtonPropsSizeOverrides {
    xSmall: true
    xXSmall: true
  }
}
